/**
 * @author xyguo
 * @description 岗位能力管理
 * @Date  2020/7/20
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { WizTableForm } from '../../../common'
import { component_tool, framework_tool ,utils_tool} from '../../../../tool';
import  ScoreEditList  from './../studentAbilityItem/inputScore/scoreEditList'

let { WizContainer ,modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class AbilityCheckItemDetail extends WizContainer {
  componentName = 'abilityCheckItemDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/train/abilityCheckCategory/abilityCheckItem/abilityCheckItemUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('abilityCheckItemUpd', initialValue)
      } else {
        initialValue = Session.get('abilityCheckItemUpd') || {};
      }
      cardTitle = '编辑'
    }else{
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.remove('abilityCheckItemUpd');
        Session.set('abilityCheckItemUpd', initialValue)
      } else {
        initialValue = Session.get('abilityCheckItemUpd') || {};
      }
    }
    this.state = {
      cardTitle: cardTitle
    }
    this.initialValue = initialValue;
  }


  _componentDidMount() {
    //获取能力项,新增取配置能力项,编辑则取星级内能力项详情
    if (this.initialValue && this.initialValue.categoryId) {
      this.doActions([
        {
          path: 'abilityItemDetail/listItemsByCondition',
          payload: {
            key: 'abilityItemDetailList',
            apiParams: {
              abilityCheckCategoryId: this.initialValue.categoryId,
              abilityCheckItemId: this.initialValue.id?this.initialValue.id:null
            }
          },
        }
      ])
    }
  }


  propsAndStateOnChange = {
    saveAbilityCheckItem: this._saveAbilityCheckItemOver.bind(this),
    abilityItemDetailList : this.getAbilityItemDetailListOver.bind(this)
  }


  _saveAbilityCheckItemOver(nextProps, nextState) {
    let param = {};
    if(this.state.cardTitle=='新增'){
      param = this.initialValue
    }else{
      param.id = this.initialValue.categoryId
      param.name = this.initialValue.categoryName
      param.state = this.initialValue.categoryState=="有效"?1:0
      param.orgName = this.initialValue.orgName
      param.positionsName = this.initialValue.positionsName
    }
    if (nextProps.saveAbilityCheckItem.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/train/abilityCheckCategory/abilityCheckItem',{...param});
    } else {
      wizNotice.error('提交失败：' + nextProps.saveAbilityCheckItem.msg);
    }
    return true;
  }

  getAbilityItemDetailListOver(nextProps, nextState) {
    let _list = [];
    if (nextProps['abilityItemDetailList'] && nextProps['abilityItemDetailList']['success'] === true) {
      let list = nextProps["abilityItemDetailList"]['data']
      list && list.forEach(val => {
        _list.push({
          id: val['id'],
        state: val['state'],
        key: val['abilityItemId'],
        name:val['abilityItemName'],
        score:val['score']===-1?undefined:val['score'],
        abilityItemId:val['abilityItemId'],
        abilityItemName:val['abilityItemName']
      })
      });
      this.initialValue.abilityItemsInfo = _list;
      return true;
    } else {
      wizNotice.error(nextProps["abilityItemDetailList"]['msg'])
      return false;
    }
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _saveAbilityCheckItem(values) {
    const { history } = this.props;
    values.abilityCheckCategoryId = this.initialValue.categoryId;
    const abilityItemDetails = values.abilityItemDetails;
    for(let i=0;i<abilityItemDetails.length;i++){
      if(abilityItemDetails[i].score===undefined || abilityItemDetails[i].score===null){
        wizNotice.warn(abilityItemDetails[i].name+":目标能力值不能为空");
        return;
      }
    }
    // abilityItemDetails.forEach(data=>{
    //   if(!data.score){
    //     wizNotice.warn(data.name+":目标能力值不能为空");
    //     return;
    //   }
    // })
    let apiPath = "abilityCheckItem/add";
      if (this.initialValue.id) {
        apiPath = "abilityCheckItem/update"
      }
      this.doAction({
        path: apiPath,
        payload: {
          key: "saveAbilityCheckItem",
          apiParams: {
            ...values
          }
        }
      });
  }


  // fitterFieldsValue(fieldsValue) {
  //   let fitterValues = {};
  //   Object.keys(fieldsValue).forEach(key => {
  //     const value = fieldsValue[key];
  //   });
  //   return fitterValues;
  // }

  _render() {
    const { abilityItemDetailLoading, abilityCheckItemLoading } = this.props;
    let { cardTitle } = this.state;
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue.id
        },
        name: "id"
      },

      {
        title: "能力评估星级",
        name: "name",
        formItem: {
          maxlength: 20,
          placeholder: '同一能力考核项目下星级名称不可重复,限制长度20个字',
          rules: [{
            required: true,
            message: '请输入能力评估星级',
          }],
          initialValue: this.initialValue.name
        },
      },
      {
        title: "顺序",
        name: "sort",
        formItem: {
          type: 'number',
          max:99,
          min:1,
          rules: [{
            required: true,
            message: '请输入顺序',
          }],
          // maxlength: 2,
          // placeholder: '能力评估星级顺序只可输入数字',
          // rules: [{
          //   required: true,
          //   pattern: /^\+?[1-9]\d*$/,
          //   message: '顺序仅支持输入大于0的数字'
          // }],
          initialValue: this.initialValue.sort
        },
      },

      {
        title: "能力项",
        name: "abilityItemDetails",
        formItem: {
          type: 'diy',
          diy: ScoreEditList,
          simplify:true,
          initialValue:  this.initialValue.abilityItemsInfo? this.initialValue.abilityItemsInfo:[],
          rules: [{
            required: true,
            message: '请添加能力项',
          }]
        }
      },


      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ],
        formItem: {
          initialValue:  this.initialValue.state ? this.initialValue.state:1,
          type: 'radio',
          rules: [{
            required: true,
            message: '请选择状态',
          }],
        }
      }

    ]


    let onSubmit = this._saveAbilityCheckItem.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }



    return <WizCard>
      <WizSpin tip={'加载中'} spinning={abilityItemDetailLoading || abilityCheckItemLoading}>
        <WizForm key='abilityForm' className={'form-inline'} {...formProps} />
      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { abilityCheckItem,abilityItemDetail } = state;
  const  saveAbilityCheckItem= modelUtils.getModelEntity(abilityCheckItem, "saveAbilityCheckItem");
  const abilityItemDetailList = modelUtils.getModelEntity(abilityItemDetail, "abilityItemDetailList");
  const load = modelUtils.getLoadingState(state, ['abilityCheckItem','abilityItemDetail']);
  return {
    saveAbilityCheckItem,
    abilityItemDetailList,
    ...load
  }
};

export default connect(mapStateToProps)(AbilityCheckItemDetail);
